<template>
  <div :style="styleName" name="tinymce">
    <div
      :class="{ fullscreen: fullscreen }"
      class="tinymce-container editor-container"
    >
      <div :id="tinymceId" class="tinymce-textarea"></div>
    </div>
  </div>
</template>
<script>
import Net from '@/constants'
// import plainBtn from '@/components/Buttons/plainBtn'
import tinymce from 'tinymce/tinymce'
// import 'tinymce/themes/mobile/theme'
// import 'tinymce/themes/modern/theme'
// 按示例初始化发现编辑器不显示，报“theme.js:1 Uncaught SyntaxError: Unexpected token <”这个错
// 需要手动引入tinymce主题，在init({})方法里加theme: 'silver',没用。
import 'tinymce/themes/silver/theme'
import plugins from './plugins'
import toolbar from './toolbar'
import zhCN from './lang/zh_CN'
import 'tinymce/plugins/image' // 插入上传图片插件
import 'tinymce/plugins/media' // 插入视频插件
import 'tinymce/plugins/table' // 插入表格插件
import 'tinymce/plugins/lists' // 列表插件
import 'tinymce/plugins/wordcount' // 字数统计插件
import 'tinymce/plugins/link' // 字数统计插件
import 'tinymce/plugins/charmap' // 特殊字符
import 'tinymce/plugins/hr' // 横线
import 'tinymce/plugins/pagebreak' // 虚线
import 'tinymce/plugins/insertdatetime' // 时间
import 'tinymce/plugins/preview' // 预览
import 'tinymce/plugins/fullscreen' // 全屏
import './plugin'
// import 'tinymce/plugins/fontsizeFormats' // 文字大小

import { getToken } from '@/utils/auth'
import encryption from '@/utils/encryption.js' // 请求加密

export default {
  name: 'Tinymce',
  components: {},
  props: {
    id: {
      type: String,
      default () {
        return (
          'vue-tinymce-' +
          +new Date() +
          ((Math.random() * 1000).toFixed(0) + '')
        )
      }
    },
    defaultText: {
      type: String,
      default () {
        return ''
      }
    },
    defaultUrl: {
      type: String,
      default () {
        return ''
      }
    }, // 富文本默认图片视频音频字符串url
    text: {
      type: String,
      default () {
        return ''
      }
    },
    url: {
      type: String,
      default () {
        return ''
      }
    }, // 富文本默认图片视频音频字符串url
    styleName: {
      type: String,
      default () {
        return ''
      }
    }, // 自定义工具
    toolbar: {
      type: String,
      default () {
        return ''
      }
    }, // 置灰
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      content: this.value,
      title: '',
      defUrl: '', // 默认
      defText: '', // 默认
      changeText: '', // 实时更新
      changeUrl: '', // 实时更新,
      images_upload_handler: (blobInfo, success, failure) => {
        const formdata = new FormData()
        formdata.append('imgData', blobInfo.base64())
        formdata.append('name', blobInfo.blob().name)
        formdata.append('size', blobInfo.blob().size)
        formdata.append('type', blobInfo.blob().type)
        console.log(blobInfo.blob())
        this.$api.uploadImage(formdata).then((res) => {
          console.log(res)
          success(res.info.path)
        })
      }
    }
  },
  // watch: {
  // value(val) {
  //   if (!this.hasChange && this.hasInit) {
  //     this.$nextTick(() =>
  //       window.tinymce.get(this.tinymceId).setContent(val || '')
  //     );
  //   }
  // }
  // },
  created () {},
  mounted () {
    if (!this.defUrl && this.defaultUrl) {
      this.defUrl = this.defaultUrl
    }
    if (!this.defText && this.defaultText) {
      this.defText = this.defaultText
    }
    if (this.changeText !== this.text) {
      this.changeText = this.text
    }
    if (this.changeUrl !== this.url) {
      this.changeUrl = this.url
    }
    // 注： 在此需要传入一个空对象
    this.initTinymce({})
    this.setContent(this.changeText || this.defaultText)
    // 给父组件发送数据
    this.emitOnChange()
  },
  watch: {
    defaultUrl: {
      handler (newVal) {
        if (!this.defUrl && newVal) {
          this.defUrl = newVal
          // 给父组件发送数据
          this.emitOnChange()
        }
      }
    },
    url: {
      handler (newVal) {
        if (this.changeUrl !== newVal) {
          this.changeUrl = newVal
          // 给父组件发送数据
          this.emitOnChange()
        }
      }
    },
    defaultText: {
      handler (newVal) {
        if (!this.defText && newVal) {
          this.defText = newVal
          this.setContent(this.changeText || this.defText)
          // 给父组件发送数据
          this.emitOnChange()
        }
      }
    },
    disabled: {
      handler (newVal) {
        window.tinymce.get(this.tinymceId).readonly = newVal
      }
    },
    text: {
      handler (newVal) {
        if (this.changeText !== newVal) {
          this.changeText = newVal
          this.setContent(this.changeText || this.defText)
          // 给父组件发送数据
          this.emitOnChange()
        }
      }
    }
  },
  // beforeUpdated() {
  //   debugger
  //   if ((!this.defUrl && this.defaultUrl) || (this.changeUrl !== this.url)) {

  //   }
  //   if ((!this.defText && this.defaultText) || (this.changeText !== this.text)) {

  //   }
  // },

  activated () {
    this.initTinymce()
  },
  deactivated () {
    this.destroyTinymce()
  },
  destroyed () {
    this.destroyTinymce()
  },
  methods: {
    initTinymce () {
      const _this = this
      // window.tinymce.baseURL = '/tinymces/tinymce'
      window.tinymce = tinymce
      window.tinymce.addI18n('zh_CN', zhCN)
      window.tinymce.init({
        readonly: this.disabled,
        language: 'zh_CN',
        selector: `#${this.tinymceId}`,
        // 安装之后，在 node_modules 中找到 tinymce/skins 目录，然后将 skins 目录拷贝到 public 的 tinymce 目录下
        // 必须加 skin_url 否则会报错
        // skin_url: "/lxjh/tinymce/skins/ui/oxide",

        skin_url: '/tinymce/skins/ui/oxide',
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
        fontsize_formats: '14px 16px 20px 24px 32px',
        toolbar: this.toolbar ? this.toolbar : toolbar, // this.toolbar.length > 0 ? this.toolbar : ,
        // menubar: this.toolbar ? false : this.menubar,
        menubar: false, // 菜单栏
        plugins,
        elementpath: false, // 去除富文本底部展示标签
        file_picker_types: 'image media',
        file_picker_callback (callback, value, meta) {
          // 要先模拟出一个input用于上传本地文件
          const input = document.createElement('input')
          input.setAttribute('type', 'file')
          // 你可以给input加accept属性来限制上传的文件类型
          // 例如：input.setAttribute('accept', '.jpg,.png');
          input.click()
          // eslint-disable-next-line func-names
          input.onchange = function () {
            const file = this.files[0]
            if (
              (meta.filetype === 'media' &&
                (file.type === 'audio/mp3' || file.type === 'video/mp4')) ||
              (meta.filetype === 'image' &&
                file.type.substring(0, 5) === 'image')
            ) {
              if (file.type === 'video/mp4' && file.size > 1024 * 1024 * 300) {
                _this.$message({
                  message: '视频大小不能超过300M！',
                  type: 'warning'
                })
                return
              }
              const xhr = new XMLHttpRequest()
              xhr.withCredentials = false
              xhr.open('POST', Net.baseUrl + '/common/upload')
              xhr.setRequestHeader('Authorization', 'CsxhBearer ' + getToken())
              xhr.onload = () => {
                if (xhr.status !== 200) {
                  return
                }

                // const json = JSON.parse(xhr.responseText)
                var json = xhr.response.replaceAll('"', '')
                json = JSON.parse(
                  encryption.decrypt(
                    'w!c_@y(0^sz-xd=h',
                    json
                  )
                )
                // if (!json || typeof json.location !== 'string') {
                //     failure(`Invalid JSON: ${  xhr.responseText}`);
                //     return;
                // }
                if (_this.defUrl) {
                  _this.defUrl += `,${Net.baseUrl + json.relativePath}`
                } else {
                  _this.defUrl += `${Net.baseUrl + json.relativePath}`
                }
                callback(json.url)
              }
              const formData = new FormData()
              formData.append('file', file, file.name)
              xhr.send(formData)
            }
          }
        },
        media_alt_source: false,
        media_poster: false,
        video_template_callback (data) {
          if (data.source1.includes('mp4')) {
            return `<video width="${data.width}" height="${data.height}  "${
              data.poster ? ` poster="${data.poster}"` : ''
            } controls="controls" controlslist="nodownload" >\n <source src="${data.source1}"${
              data.source1mime ? ` type="${data.source1mime}"` : ''
            } />\n${
              data.source2
                ? `<source src="${data.source2}"${
                    data.source2mime ? ` type="${data.source2mime}"` : ''
                  } />\n`
                : ''
            }</video>`
          }
          return `<audio width="${data.width}" height="${data.height}"${
            data.poster ? ` poster="${data.poster}"` : ''
          } controls="controls">\n<source src="${data.source1}"${
            data.source1mime ? ` type="${data.source1mime}"` : ''
          } />\n${
            data.source2
              ? `<source src="${data.source2}"${
                  data.source2mime ? ` type="${data.source2mime}"` : ''
                } />\n`
              : ''
          }</audio>`
        },
        branding: false,
        link_title: false,
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        // link_title: false,
        // menubar: false,
        nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        init_instance_callback: (editor) => {
          // console.log('init_instance_callback: defText = ', _this.defText);
          if (_this.defText) {
            editor.setContent(this.changeText || _this.defText)
          }
          // _this.hasInit = true;
          editor.on('NodeChange Change KeyUp SetContent', () => {
            // this.hasChange = true;
            // this.$emit('onChange', editor.getContent(), this.defUrl);
            this.changeText = this.getContent()
            this.emitOnChange()
          })
        },
        setup (editor) {
          editor.on('FullscreenStateChanged', (e) => {
            _this.fullscreen = e.state
          })
          // tab键

          editor.on('keydown', function (evt) {
            if (evt.keyCode === 9) {
              if (evt.shiftKey) {
                editor.execCommand('Outdent')
              } else {
                editor.execCommand('Indent')
              }
              evt.preventDefault()
              evt.stopPropagation()
            }
          })
        }
      })
    },
    destroyTinymce () {
      const tinymce = window.tinymce.get(this.tinymceId)
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen')
      }
      if (tinymce) {
        tinymce.destroy()
      }
    },
    setContent (value) {
      window.tinymce.get(this.tinymceId).setContent(value)
    },
    getContent () {
      return window.tinymce.get(this.tinymceId).getContent() || ''
    },
    emitOnChange () {
      this.$emit(
        'onChange',
        this.getContent() || this.changeText || this.defText,
        this.changeUrl || this.defUrl
      )
    }
  }
}
</script>
<style scoped lang="less">
.tinymce-container {
  height: 100%;
  /deep/ .tox-tinymce {
    height: 100% !important;
  }
}
</style>
